module.exports = __webpack_public_path__ + "img/shujuyunying@2x.7a3b50b8.png";